import axios from "axios";
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const coachDashApi = {
  get: (email) => axios.get(`${BASE}/coach/dashboard?email=${encodeURIComponent(email)}`).then((r) => r.data),
  completeBooking: (email, booking_id) =>
    axios.post(`${BASE}/coach/dashboard/${encodeURIComponent(email)}/complete-booking`, { booking_id }).then((r) => r.data),
  startOnboarding: (email) => axios.post(`${BASE}/coach-onboarding/start`, { email }).then((r) => r.data),
  getAvailability: (email) =>
    axios.get(`${BASE}/coach/dashboard/${encodeURIComponent(email)}/availability`).then((r) => r.data.availability),
  saveAvailability: (email, payload) =>
    axios.patch(`${BASE}/coach/dashboard/${encodeURIComponent(email)}/availability`, payload).then((r) => r.data.availability),
  getProfile: (email) =>
    axios.get(`${BASE}/coach/dashboard/${encodeURIComponent(email)}/profile`).then((r) => r.data.profile),
  saveProfile: (email, payload) =>
    axios.patch(`${BASE}/coach/dashboard/${encodeURIComponent(email)}/profile`, payload).then((r) => r.data.profile),
};

export const DASH_TESTIDS = {
  page: "coach-dashboard",
  loginForm: "coach-dashboard-login",
  loginEmail: "coach-dashboard-login-email",
  loginSubmit: "coach-dashboard-login-submit",
  logout: "coach-dashboard-logout",

  stripeCard: "coach-dashboard-stripe-card",
  stripeStatus: "coach-dashboard-stripe-status",
  stripeOnboardCta: "coach-dashboard-stripe-onboard-cta",

  earningsGross: "coach-dashboard-earnings-gross",
  earningsFee: "coach-dashboard-earnings-fee",
  earningsNet: "coach-dashboard-earnings-net",

  upcomingList: "coach-dashboard-upcoming",
  upcomingItem: (id) => `coach-dashboard-upcoming-${id}`,
  completeBookingBtn: (id) => `coach-dashboard-complete-${id}`,

  pastList: "coach-dashboard-past",
  cancelledList: "coach-dashboard-cancelled",
  reviewsList: "coach-dashboard-reviews",
  emptyState: (kind) => `coach-dashboard-empty-${kind}`,

  // Tabs
  tab: (id) => `coach-dashboard-tab-${id}`,
  tabPanel: (id) => `coach-dashboard-panel-${id}`,

  // Overview
  overviewSection: "coach-dashboard-overview",
  overviewCard: (kind) => `coach-dashboard-overview-${kind}`,

  // Profile editor
  profileSection: "coach-profile-section",
  profileHeadline: "coach-profile-headline",
  profileBio: "coach-profile-bio",
  profileSpecialties: "coach-profile-specialties",
  profilePrice: "coach-profile-price",
  profileSave: "coach-profile-save",

  // Availability editor
  availabilitySection: "coach-availability-section",
  availabilityOnline: "coach-availability-online",
  availabilityInPerson: "coach-availability-in-person",
  availabilityDuration: "coach-availability-duration",
  availabilityPrice: "coach-availability-price",
  availabilityTimezone: "coach-availability-timezone",
  availabilityWeekdayToggle: (wd) => `coach-availability-weekday-${wd}`,
  availabilityStart: (wd) => `coach-availability-start-${wd}`,
  availabilityEnd: (wd) => `coach-availability-end-${wd}`,
  availabilitySave: "coach-availability-save",
};
